import MobileWorkerDetail from "./MobileWorkerDetail";

export default MobileWorkerDetail;
